import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Permission } from "../types";

interface PermissionState {
  listPermission: Permission | null;
}

const initialState: PermissionState = {
	listPermission: null,
};

export const permissionSlice = createSlice({
	name: "permission",
	initialState,
	reducers: {
		setListPermission: (state, action) => {
			state.listPermission = action.payload.data;
		},
	},
});

export const selectListPermission = (state: RootState) =>
	state.permission.listPermission;

export const { setListPermission } = permissionSlice.actions;

export const getListPermissionAsync = createAction(
	"permission/getListPermissionAsync",
);

export default permissionSlice.reducer;
